export default class Selection {}
